import type { TenantConfig } from './TenantConfig'
import { isProd, productionLoginUsers } from '@/lib/env'

export interface TenantUser {
  email: string
  password: string
  tenantId: string
  role: 'admin' | 'viewer'
}

const ORDERMAGE_TENANT: TenantConfig = {
  id: 'ordermage',
  name: 'Objednáme · OrderMage',
  branding: {
    motto: 'Jeden systém pro celý podnik',
  },
  api: {
    baseUrl: import.meta.env.VITE_API_BASE ?? '/api/v1',
    dataSource: (import.meta.env.VITE_DATA_SOURCE as 'mock' | 'api' | undefined) ?? 'mock',
    mode: 'polling',
    apiKey: import.meta.env.VITE_DASHBOARD_API_KEY,
  },
  slides: {
    enabled: ['overall', 'sales', 'map', 'ordersLive'],
  },
  milestones: {
    defaultsEnabled: true,
  },
  locale: 'cs',
  theme: 'dark',
  scale: {
    locations: 0,
    mrrBaselineCzk: 0,
    fixedMonthlyCzk: 0,
  },
}

const DEMO_TENANT: TenantConfig = {
  id: 'demo',
  name: 'Demo Bistro Group',
  branding: {
    primaryColor: '#7B1FA2',
    accentColor: '#FFB300',
    motto: 'Demo tenant — funny numbers',
  },
  api: {
    baseUrl: '/api/v1',
    dataSource: 'mock',
  },
  slides: {
    enabled: ['overall', 'sales', 'support', 'teams'],
  },
  milestones: {
    defaultsEnabled: true,
  },
  locale: 'cs',
  theme: 'dark',
  scale: {
    locations: 48,
    mrrBaselineCzk: 220_000,
    fixedMonthlyCzk: 140_000,
  },
}

export const TENANTS: TenantConfig[] = isProd
  ? [ORDERMAGE_TENANT]
  : [ORDERMAGE_TENANT, DEMO_TENANT]

const DEV_USERS: TenantUser[] = [
  { email: 'admin@objedname.eu', password: 'ordermage', tenantId: 'ordermage', role: 'admin' },
  { email: 'tv@objedname.eu', password: 'ordermage', tenantId: 'ordermage', role: 'viewer' },
  { email: 'demo@demo.cz', password: 'demo', tenantId: 'demo', role: 'admin' },
]

export function getAuthUsers(): TenantUser[] {
  if (!isProd) return DEV_USERS
  return productionLoginUsers()
}

export const USERS: TenantUser[] = getAuthUsers()

export function getTenantById(id: string): TenantConfig | undefined {
  return TENANTS.find((t) => t.id === id)
}
